export class Star {
  color: StarColor = StarColor.White;
  size = 1;
  period = 3;
  x: number;
  y: number;
}

export enum StarColor {
  Red = '#fbb',
  Orange = '#fdb',
  Yellow = '#ffc',
  Green = '#cfc',
  Blue = '#bdf',
  Indigo = '#dbf',
  Violet = '#fbf',
  White = '#fff',
}
